var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.953125H513V342.953H0V0.953125Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.05273H256.5V172.053H0V1.05273Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 0.953125H233.4L160 49.8531V0.953125H96V49.8531L22.6 0.953125H0V23.6531L46.1 54.3531H0V118.353H46.1L0 149.053V171.653H22.6L96 122.753V171.653H160V122.753L233.4 171.653H256V149.053L209.9 118.353H256V54.3531H209.9L256 23.6531V0.953125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 0.953125H112V70.3531H0V102.353H112V171.653H144V102.353H256V70.3531H144V0.953125Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 171.653V160.653L62.5 118.353H85.1L7.3 171.653H0ZM7.3 1.05273L85.1 54.2527H62.5L0 12.0527V1.05273H7.3ZM256 1.05273V12.0527L193.5 54.3527H170.9L248.7 1.05273H256ZM248.7 171.653L170.9 118.353H193.5L256 160.653V171.653H248.7Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.9 100.894V200.584C316.9 260.394 396.65 300.274 396.65 300.274C396.65 300.274 476.4 260.394 476.4 200.584V100.894H316.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.37 260.394H343.93C367.06 285.474 396.65 300.274 396.65 300.274C396.65 300.274 426.24 285.474 449.37 260.394Z",
    fill: "#2F8F22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.65 260.394C418.675 260.394 436.53 242.539 436.53 220.514C436.53 198.489 418.675 180.634 396.65 180.634C374.625 180.634 356.77 198.489 356.77 220.514C356.77 242.539 374.625 260.394 396.65 260.394Z",
    fill: "#65B5D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.77 220.524C367.783 220.524 376.71 211.596 376.71 200.584C376.71 189.571 367.783 180.644 356.77 180.644C345.757 180.644 336.83 189.571 336.83 200.584C336.83 211.596 345.757 220.524 356.77 220.524Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.52 220.524C447.533 220.524 456.46 211.596 456.46 200.584C456.46 189.571 447.533 180.644 436.52 180.644C425.507 180.644 416.58 189.571 416.58 200.584C416.58 211.596 425.507 220.524 436.52 220.524Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.65 180.644C407.663 180.644 416.59 171.716 416.59 160.704C416.59 149.691 407.663 140.764 396.65 140.764C385.637 140.764 376.71 149.691 376.71 160.704C376.71 171.716 385.637 180.644 396.65 180.644Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.953125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBm);
export default __webpack_public_path__ + "static/media/BM.3a38e9de3ee3c5206577efc9ce7d4747.svg";
export { ForwardRef as ReactComponent };